::ng-deep particle-activity-cards{min-width:100%;max-width:385px;height:100%;display:inline-flex;flex-direction:column}::ng-deep particle-activity-cards .activity-feeds{flex-grow:1}
/*# sourceMappingURL=activity-cards.component-ZIO6EACR.css.map */
